import { deleteArtMedida, getArtMedidasPanel,postArtMedida } from "../../services/ArticulosMedidasServices";
import { ArticulosMedidasContext } from "./ArticulosMedidasContext"

export const ArticulosMedidasState = ({ children }) => {
    const getArtMedidasPanelData = async (searchRam,searchTerm, page, perPage) => {
        let res = await getArtMedidasPanel(searchRam,searchTerm, page, perPage)
        return res;
    }

    const deleteArticuloMedidaData = async (body) => {
        const res = await deleteArtMedida(body)
        return res
    }

    const postArticuloMedidaData = async (body) => {
        const res = await postArtMedida(body)
        return res
    }

    return <ArticulosMedidasContext.Provider value={{
        deleteArticuloMedidaData,
        getArtMedidasPanelData,
        postArticuloMedidaData
    }} >
        {children}
    </ArticulosMedidasContext.Provider>
}